import { gql } from 'apollo-angular';

export const getBrandDataQuery = /* GraphQL */ gql`
  {
    shop {
      description
      name
      termsOfService {
        body
      }
      privacyPolicy {
        body
      }
      moneyFormat
      paymentSettings {
        acceptedCardBrands
        cardVaultUrl
        currencyCode
        enabledPresentmentCurrencies
        shopifyPaymentsAccountId
        supportedDigitalWallets
      }
      brand {
        colors {
          primary {
            background
            foreground
          }
          secondary {
            background
            foreground
          }
        }
        coverImage {
          id
          image {
            url
            height
            width
            altText
          }
          previewImage {
            url
            height
            width
            altText
          }
        }
      }
    }
  }
`;
